module.exports = __webpack_public_path__ + "img/170990.458548c5.png";